import React from 'react';
import { SHOW_LANGUAGE_SWITCH, useI18n } from './index';
import './LanguageSwitch.css';

const LanguageSwitch = ({ variant = 'login' }) => {
    const { language, languages, setLanguage, t } = useI18n();
    if (!SHOW_LANGUAGE_SWITCH) return null;

    return (
        <div className={`lang-switch lang-switch-${variant}`} role="group" aria-label={t('common.language')}>
            {languages.map((item) => {
                const selected = language === item.code;
                return (
                    <button
                        key={item.code}
                        type="button"
                        className={`lang-switch-btn${selected ? ' is-active' : ''}`}
                        aria-pressed={selected}
                        title={item.native}
                        onClick={() => setLanguage(item.code)}
                    >
                        {item.short}
                    </button>
                );
            })}
        </div>
    );
};

export default LanguageSwitch;
